import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { publicApi } from "@/lib/api";
import { toast } from "sonner";
import { HardHat, Zap, CheckCircle2 } from "lucide-react";

function Wrap({ children }) {
  return (
    <div className="min-h-screen bg-slate-950 text-white flex flex-col">
      <header className="border-b-4 border-orange-600 bg-slate-900">
        <div className="max-w-4xl mx-auto px-4 h-20 flex items-center">
          <Link to="/"><img src="/logo-ploegbord.webp?v=8" alt="Ploegbord" className="h-12 md:h-14 w-auto"/></Link>
        </div>
      </header>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="pb-card !bg-white !text-slate-900 p-6 max-w-md w-full">{children}</div>
      </div>
      <div className="pb-2 text-center text-[11px] font-bold text-slate-500 space-x-3" data-testid="password-reset-legal">
        <Link to="/privacy" className="hover:text-orange-500 underline decoration-dotted">Privacyverklaring</Link>
        <span className="text-slate-700">·</span>
        <Link to="/voorwaarden" className="hover:text-orange-500 underline decoration-dotted">Algemene voorwaarden</Link>
      </div>
    </div>
  );
}

export function Forgot() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await publicApi.post("/auth/forgot-password", { email }); setSent(true); }
    catch { toast.error("Er ging iets mis"); } finally { setBusy(false); }
  };
  return (
    <Wrap>
      {sent ? (
        <>
          <div className="w-14 h-14 rounded-full bg-orange-600 text-white flex items-center justify-center mx-auto"><CheckCircle2 size={28}/></div>
          <div className="pb-heading text-xl font-black text-center mt-3">Check je mail</div>
          <div className="text-center text-slate-600 font-semibold mt-1 text-sm">Als er een account bestaat met dit adres, ontvang je binnen een minuut een resetlink (1 uur geldig).</div>
          <Link to="/login" className="pb-btn-outline w-full mt-4 text-center flex items-center justify-center">Terug naar inloggen</Link>
        </>
      ) : (
        <>
          <div className="text-orange-600 text-xs font-black uppercase tracking-widest">Wachtwoord vergeten</div>
          <div className="pb-heading text-2xl font-black mt-1">Reset je wachtwoord</div>
          <form onSubmit={submit} className="mt-4 space-y-3">
            <input type="email" required className="pb-input" placeholder="jouw@email.nl" value={email} onChange={(e)=>setEmail(e.target.value)} data-testid="forgot-email"/>
            <button type="submit" disabled={busy} className="pb-btn-primary w-full !min-h-[48px]" data-testid="forgot-submit"><Zap size={16}/> {busy ? "Verzenden…" : "Stuur resetlink"}</button>
          </form>
          <Link to="/login" className="block text-center mt-3 text-sm font-bold hover:text-orange-600">Terug naar inloggen</Link>
        </>
      )}
    </Wrap>
  );
}

export function Reset() {
  const { token } = useParams();
  const nav = useNavigate();
  const [pw, setPw] = useState(""); const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false); const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("Minimaal 8 tekens");
    if (pw !== pw2) return toast.error("Wachtwoorden komen niet overeen");
    setBusy(true);
    try { await publicApi.post("/auth/reset-password", { token, password: pw }); setDone(true); setTimeout(()=>nav("/login"), 1500); }
    catch (err) { toast.error(err?.response?.data?.detail || "Reset mislukt"); }
    finally { setBusy(false); }
  };
  return (
    <Wrap>
      {done ? (
        <>
          <div className="w-14 h-14 rounded-full bg-orange-600 text-white flex items-center justify-center mx-auto"><CheckCircle2 size={28}/></div>
          <div className="pb-heading text-xl font-black text-center mt-3">Klaar!</div>
        </>
      ) : (
        <>
          <div className="text-orange-600 text-xs font-black uppercase tracking-widest">Nieuw wachtwoord</div>
          <div className="pb-heading text-2xl font-black mt-1">Kies een nieuw wachtwoord</div>
          <form onSubmit={submit} className="mt-4 space-y-3">
            <input type="password" required minLength={8} className="pb-input" placeholder="min. 8 tekens" value={pw} onChange={(e)=>setPw(e.target.value)} data-testid="reset-pw"/>
            <input type="password" required minLength={8} className="pb-input" placeholder="Herhaal" value={pw2} onChange={(e)=>setPw2(e.target.value)} data-testid="reset-pw2"/>
            <button type="submit" disabled={busy} className="pb-btn-primary w-full !min-h-[48px]" data-testid="reset-submit"><Zap size={16}/> {busy ? "Instellen…" : "Wachtwoord instellen"}</button>
          </form>
        </>
      )}
    </Wrap>
  );
}
